import React from 'react';
import AmpPageActions from 'components/AmpPageActions';
import SitePageActions from 'components/SitePageActions';
import { imageUrl } from 'util/images';

const PINTEREST_IMAGE_OPTS = {
  width: 1000
};

function PageActions(props) {
  const { postImage, isAmp, ...rest } = props;
  // Parse props
  const parsed = {
    postImage: postImage
      ? imageUrl(postImage, PINTEREST_IMAGE_OPTS)
      : undefined,
    ...rest
  };
  return isAmp ? (
    <AmpPageActions {...parsed} />
  ) : (
    <SitePageActions {...parsed} />
  );
}

export default PageActions;
